var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoSm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 2.00673C8.66065 1.33533 9.91961 0.814985 11.25 0.472566V29.5274C9.91961 29.185 8.66065 28.6647 7.5 27.9933V2.00673ZM3.75 5.07816C1.41614 7.72241 0 11.1958 0 15C0 18.8042 1.41614 22.2776 3.75 24.9218V5.07816Z",
    fill: "#2B99FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9998 30C14.9999 30 14.9999 30 15 30C23.2843 30 30 23.2843 30 15C30 6.71573 23.2843 0 15 0C14.9999 0 14.9999 8.3719e-10 14.9998 8.3719e-10V30Z",
    fill: "#FFBF60"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSm);
export default __webpack_public_path__ + "static/media/logo-sm.171d9bbe3106076cd2cf4942526423f2.svg";
export { ForwardRef as ReactComponent };